import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicCheckOut({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M13.75 7.45l-2.5-2.25c-.15-.1-.3-.2-.5-.2-.4 0-.75.35-.75.75 0 .2.1.4.25.55l1.05.95H6.75c-.4 0-.75.35-.75.75s.35.75.75.75h4.55l-1.05.95a.8.8 0 00-.25.55c0 .4.35.75.75.75.2 0 .35-.05.5-.2l2.5-2.25A.8.8 0 0014 8c0-.2-.1-.4-.25-.55zM2 8v5.75c0 .45.35.75.75.75H8.5c.4 0 .75-.35.75-.75S8.9 13 8.5 13h-5V3h5c.4 0 .75-.35.75-.75S8.9 1.5 8.5 1.5H2.75c-.4 0-.75.35-.75.75V8z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicCheckOut.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicCheckOut.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicCheckOut svgRef={ref} {...props} />);
export default ForwardRef;
